import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ProductEntry, StoreOrder } from '../../../../SharedTypes/Models';

const API_URL = '/api/entries/';
const ORDERBOOK_API_URL = '/api/orderbook/';

export const useGetWasteStatus = (
	date: string,
	locationId: number,
	skip: boolean = false
) => {
	return useQuery(
		['waste-status', { location: locationId, date }],
		() => {
			const request = `${API_URL}waste/status/${date}/${locationId}`;

			return axios<{ result: ProductEntry[] }>(request);
		},
		{
			select: ({ data }) => {
				return data.result;
			},
			enabled: !skip,
		}
	);
};

export const useGetOrderStatus = (
	startDate: string,
	endDate: string,
	locationId: number,
	skip: boolean = false
) => {
	return useQuery(
		['order-status', { location: locationId, startDate, endDate }],
		() => {
			const request = `${API_URL}status/${startDate}/${endDate}/${locationId}`;

			return axios<{ result: ProductEntry[] }>(request);
		},
		{
			select: ({ data }) => {
				return data.result;
			},
			enabled: !skip,
		}
	);
};

export const useGetStoreOrderStatus = (
	startDate: string,
	endDate: string,
	locationId: number,
	skip: boolean = false
) => {
	return useQuery(
		['store-order-status', { location: locationId, startDate, endDate}],
		() => {
			const request = `${ORDERBOOK_API_URL}status/store-order/${startDate}/${endDate}/${locationId}`;

			return axios<{ result: StoreOrder[] }>(request);
		},
		{
			select: ({ data }) => {
				return data.result;
			},
			enabled: !skip,
		}
	);
};

export const useGetProductionOrderStatus = (
	startDate: string,
	endDate: string,
	locationId: number,
	skip: boolean = false
) => {
	return useQuery(
		['production-order-status', { location: locationId, startDate, endDate}],
		() => {
			const request = `${ORDERBOOK_API_URL}status/production-order/${startDate}/${endDate}/${locationId}`;

			return axios<{ result: StoreOrder[] }>(request);
		},
		{
			select: ({ data }) => {
				return data.result;
			},
			enabled: !skip,
		}
	);
};